import { Component, Input, OnInit } from '@angular/core';
import { UserData, UserProfileData } from '../../services/data.service';

@Component({
    selector: 'app-pg-user',
    templateUrl: './pg-user.component.html',
    styleUrls: ['./pg-user.component.scss'],
    standalone: false
})
export class PgUserComponent implements OnInit {
    constructor() { }

    @Input() user:UserData
    @Input() profile:UserProfileData

    @Input() vertical:boolean
    @Input() small:boolean

    ngOnInit() {}   
}
